<template>
    <div class="fitnessplan">
        <VueLoading :active.sync="showLoadingIndicator" :can-cancel="true"></VueLoading>

        <!-- TABS -->
        <div class="tabs tabs--fullwidth">
            <div class="tabs__content">
                <v-btn to="/fitnessplan/calendar" text v-ripple="false">Übersicht</v-btn>
                <v-btn to="/fitnessplan" text v-ripple="false">Als Nächstes</v-btn>
                <v-btn class="is-active" text v-ripple="false">Trainingspläne</v-btn>
            </div>
        </div>

        <!-- 3 Beispiele für Fitnessplan-Zustände -->
            <div v-for="challenge in getActiveChallenges" v-bind:key="challenge.id"
                 class="fitnessplan__item fitnessplan__item--active">
                <div class="fitnessplan__item__content">
                    <div class="fitnessplan__item__badge"><span>Aktiv</span>・ {{ challenge.badge }}</div>
                    <h3 class="fitnessplan__item__title">{{ challenge.title }}</h3>
                    <img :src="'https://app.sportlerplus.com/scaled/800/' + challenge.image_url"
                         class="fitnessplan__item__image" alt="">
                </div>
                <div class="fitnessplan__item__footer">
<!--                    <div class="fitnessplan__item__footer__button">-->
<!--                        <img src="@/assets/ic_16_fitnessplan_edit.svg" alt="">-->
<!--                        Bearbeiten-->
<!--                    </div>-->
                    <div @click="confirmDeleteChallenge(challenge)" class="fitnessplan__item__footer__button">
                        <img src="@/assets/ic_16_fitnessplan_cancel.svg" alt="">
                        Beenden
                    </div>
                </div>
            </div>

            <div v-for="challenge in getCompletedChallenges" v-bind:key="challenge.uniqueChallengeId"
                 class="fitnessplan__item">
                <div class="fitnessplan__item__content"  @click="openChallengeSuccess(challenge)">
                    <div class="fitnessplan__item__badge"><span>Bereits absolviert</span>・{{
                            challenge.badge
                        }}
                    </div>
                    <h3 class="fitnessplan__item__title">{{ challenge.title }}</h3>
                    <img :src="'https://app.sportlerplus.com/scaled/800/' + challenge.image_url"
                         class="fitnessplan__item__image" alt="">
                </div>
                <div v-if="isNotActiveChallenge(challenge)" class="fitnessplan__item__footer">
                    <div @click="openFitnessplanDetailModal(challenge)" class="fitnessplan__item__footer__button">
                        <img src="@/assets/ic_24_play.svg" alt="">
                        Erneut starten
                    </div>
                </div>
            </div>

            <div v-for="challenge in selectableChallenges" v-bind:key="challenge.id"
                 class="fitnessplan__item" @click="openFitnessplanDetailModal(challenge)">
                <div class="fitnessplan__item__content">
                    <div class="fitnessplan__item__badge">
                        <span>Noch nicht absolviert</span>・{{ challenge.badge }}
                    </div>
                    <h3 class="fitnessplan__item__title">{{ challenge.title }}</h3>
                    <img :src="'https://app.sportlerplus.com/scaled/800/' + challenge.image_url"
                         class="fitnessplan__item__image" alt="">
                </div>
            </div>
        <ConfirmDeleteChallengeModal @deleteFitnessPlanChallenge="deleteFitnessPlanChallenge"
                                     :fitnessPlanEvent="currentChallenge"
                                     name="confirmDeleteChallengeModal"></ConfirmDeleteChallengeModal>


        <FitnessplanDetailModal :challenge="currentChallenge"></FitnessplanDetailModal>
    </div>
</template>

<script>

import ConfirmDeleteChallengeModal from "@/components/ConfirmDeleteChallengeModal";
import FitnessplanDetailModal from '@/components/FitnessplanDetailModal';
import {analytics} from "@/firebase";
import VueLoading from 'vue-loading-overlay';
import { deleteFitnessPlanChallenge, checkChallengeStatus, getUpcomingEvents } from '@/services/fitnessPlanApi';

export default {
    name: 'FitnessplanChallenges',
    components: {ConfirmDeleteChallengeModal,FitnessplanDetailModal,VueLoading},
    data() {
        return {
            currentChallenge: {},
            startedChallenges: [], // Optimiert: Nur die nötigen Challenge-Daten statt ganzer fitnessPlan
            challengeStatusData: null, // Cloud Function Daten für Statistiken
            challenges: [],
            showLoadingIndicator: false,
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        activeChallenges() {
            return this.startedChallenges.filter(el => el.inProgress);
        },
        getActiveChallenges() {
            if (!this.challenges) { return []; }
            let userChallenges = [...this.activeChallenges];
            userChallenges.forEach(el => {
                // FIX: Challenge-Daten als Basis, aber uniqueChallengeId erhalten!
                const challengeData = this.challenges.find(c => parseInt(c.id) === parseInt(el.id));
                if (challengeData) {
                    Object.assign(el, challengeData, el); // el überschreibt challengeData!
                }
            });
            return userChallenges;
        },
        selectableChallenges() {
            if (!this.challenges) { return []; }
            return this.challenges.filter(el => {
                let c = this.activeChallenges.find(ac => parseInt(ac.id) === parseInt(el.id)) || this.completedChallenges.find(ac => parseInt(ac.id) === parseInt(el.id));
                return (c == null);
            });
        },
        completedChallenges() {
            return this.startedChallenges.filter(el => !el.inProgress);
        },
        getCompletedChallenges() {
            if (!this.challenges) { return []; }
            let userChallenges = [...this.completedChallenges];
            userChallenges.forEach(el => {
                // FIX: Challenge-Daten als Basis, aber uniqueChallengeId erhalten!
                const challengeData = this.challenges.find(c => parseInt(c.id) === parseInt(el.id));
                if (challengeData) {
                    Object.assign(el, challengeData, el); // el überschreibt challengeData!
                }
            });
            return userChallenges;
        },
    },
    methods: {
        openFitnessplanDetailModal(challenge) {
            this.currentChallenge = challenge;
            this.$modal.show('fitnessplanDetail');
        },
        closeFitnessplanDetailModal() {
            this.$modal.hide('fitnessplanDetail');
        },
        openChallengeSuccess(challenge) {
            const uniqueChallengeId = challenge.uniqueChallengeId;
            
            // Speichere Challenge-Statistiken in localStorage für Success-View
            const challengeStats = this.challengeStatusData?.challenges?.find(c => c.uniqueChallengeId === uniqueChallengeId);
            
            if (challengeStats) {
                const challengeCompletionData = {
                    uniqueChallengeId: challengeStats.uniqueChallengeId,
                    challengeId: challengeStats.challengeId, // Für Challenge-Definition Lookup
                    totalEnergyExpended: challengeStats.totalEnergyExpended,
                    totalHours: challengeStats.totalHours,
                    totalMinutes: challengeStats.totalMinutes,
                    progress: challengeStats.progress,
                    numberOfExercises: challengeStats.numberOfExercises,
                    numberOfFinishedExercises: challengeStats.numberOfFinishedExercises
                };
                
                console.log('Storing challenge completion data in localStorage:', challengeCompletionData);
                localStorage.setItem('challengeCompletionData', JSON.stringify(challengeCompletionData));
            }
            
            this.$router.push("/fitnessplan/challenge/success?unique_challenge_id=" + uniqueChallengeId);
        },
        async init() {
            this.showLoadingIndicator = true;
            try {
                await this.$store.dispatch("fetchChallenges").then(() => {
                    this.challenges = this.$store.getters.getChallenges;
                });
                
                // OPTIMIERT: Lade Challenge-Status über Cloud Function für Statistiken
                await this.loadChallengeStatus();
                
                // Fallback: Lade startedChallenges aus Store falls Cloud Function fehlschlägt
                if (!this.challengeStatusData) {
                    await this.loadStartedChallenges();
                }

                if (this.$route.query.challengeId) {
                    Object.keys(this.challenges).forEach(key => {
                        const item = this.challenges[key]
                        if (typeof this.$route.query.challengeId === 'string' && parseInt(item.id) === parseInt(this.$route.query.challengeId)) {
                            this.currentChallenge = item
                        }
                    })
                    this.$modal.show('fitnessplanDetail');
                }
                this.showLoadingIndicator = false;
            } catch (error) {
                console.error('Error initializing challenges:', error);
                this.showLoadingIndicator = false;
                throw error;
            }
        },

        confirmDeleteChallenge(activeChallenge) {
            this.currentChallenge = activeChallenge;
            this.$modal.show("confirmDeleteChallengeModal");
        },
        async deleteFitnessPlanChallenge() {
            const userId = this.$store.state.user && this.$store.state.user.user && this.$store.state.user.user.uid;
            if (!userId) {
                console.error('Benutzer nicht eingeloggt');
                return;
            }

            try {
                // Debug: Bestätige dass uniqueChallengeId vorhanden ist
                console.log('Deleting challenge:', this.currentChallenge);
                console.log('Sending to server (deleteFitnessPlanChallenge):', {
                    userId: userId,
                    eventInfo: { uniqueChallengeId: this.currentChallenge.uniqueChallengeId }
                });
                
                if (!this.currentChallenge.uniqueChallengeId) {
                    throw new Error('Keine uniqueChallengeId gefunden für Challenge: ' + JSON.stringify(this.currentChallenge));
                }
                
                // Verwende optimierte Cloud Function mit verbesserter Fehlerbehandlung
                await deleteFitnessPlanChallenge(userId, this.currentChallenge.uniqueChallengeId);

                console.log('Challenge successfully deleted on server');
                
                // Analytics und UI-Updates (client-side)
                this.$store.commit('clearMotivationTextAsDisplayed', this.currentChallenge.uniqueChallengeId);
                analytics.logEvent('cancel_challenge', { challenge_id: this.currentChallenge.id });
                
                // Optimistische UI-Update: Challenge sofort aus lokaler Liste entfernen
                const deletedChallengeId = this.currentChallenge.uniqueChallengeId;
                console.log('Optimistically removing challenge:', deletedChallengeId);
                console.log('Before optimistic removal:', this.startedChallenges.length);
                this.startedChallenges = this.startedChallenges.filter(c => c.uniqueChallengeId !== deletedChallengeId);
                console.log('After optimistic removal:', this.startedChallenges.length);
                
                // UI aktualisieren - refresh Store und dann Challenges neu laden
                await this.refreshStoreAndChallenges();
                this.$modal.hide("confirmDeleteChallengeModal");
                
            } catch (error) {
                console.error('Fehler beim Löschen der Challenge:', error);
                
                // Spezielle Behandlung für "Fitness plan not found" - Challenge trotzdem lokal entfernen
                if (error.message.includes('404') || error.message.includes('not found')) {
                    console.log('=== VERWAISTE CHALLENGE BEHANDLUNG ===');
                    console.log('Server-Fitness-Plan nicht gefunden - entferne verwaiste Challenge lokal');
                    const deletedChallengeId = this.currentChallenge.uniqueChallengeId;
                    
                    // 1. Lokal aus View entfernen
                    this.startedChallenges = this.startedChallenges.filter(c => c.uniqueChallengeId !== deletedChallengeId);
                    console.log('Challenge aus lokaler View entfernt');
                    
                    // 2. Aus Store entfernen (falls vorhanden)
                    const fitnessPlan = this.$store.getters.getFitnessplan;
                    if (fitnessPlan && fitnessPlan.startedChallenges) {
                        const originalCount = fitnessPlan.startedChallenges.length;
                        fitnessPlan.startedChallenges = fitnessPlan.startedChallenges.filter(c => c.uniqueChallengeId !== deletedChallengeId);
                        const newCount = fitnessPlan.startedChallenges.length;
                        console.log('Store bereinigt: ' + originalCount + ' -> ' + newCount + ' challenges');
                        
                        // Store aktualisieren (ohne Fallbacks)
                        this.$store.state.fitnessPlan = null; // Erzwinge Store-Refresh bei nächstem Zugriff
                    }
                    
                    // 3. Analytics und UI-Cleanup
                    analytics.logEvent('cancel_challenge', { 
                        challenge_id: this.currentChallenge.id,
                        reason: 'orphaned_data_cleanup' 
                    });
                    this.$store.commit('clearMotivationTextAsDisplayed', this.currentChallenge.uniqueChallengeId);
                    
                    console.log('=== CLEANUP ABGESCHLOSSEN ===');
                    alert('Verwaiste Challenge entfernt. Der Server-Fitness-Plan existiert nicht - lokale Daten wurden bereinigt.');
                } else {
                    alert('Fehler beim Löschen der Challenge: ' + error.message);
                }
                this.$modal.hide("confirmDeleteChallengeModal");
            }
        },
        // Store refreshen nach server-seitigen Änderungen
        async refreshStoreAndChallenges() {
            try {
                console.log('=== DEBUGGING CHALLENGE DELETION ===');
                console.log('Before refresh - startedChallenges:', this.startedChallenges.length);
                console.log('Before refresh - activeChallenges:', this.activeChallenges.length);

                const userId = this.$store.state.user && this.$store.state.user.user && this.$store.state.user.user.uid;
                if (!userId) {
                    console.error('Benutzer nicht eingeloggt');
                    return;
                }
                
                // 1. Store aktualisieren (lädt aktuellen fitnessPlan vom Server)
                const result = await getUpcomingEvents(userId, 1);
                if (result && result.challenges) {
                    this.startedChallenges = result.challenges;
                    
                    console.log('After refresh - startedChallenges:', this.startedChallenges.length);
                    console.log('After refresh - activeChallenges:', this.activeChallenges.length);
                    console.log('All startedChallenges details:', this.startedChallenges.map(c => ({
                        id: c.id,
                        uniqueChallengeId: c.uniqueChallengeId,
                        inProgress: c.inProgress,
                        title: c.title || 'NO_TITLE'
                    })));
                } else {
                    console.log('No fitness plan received from server');
                    this.startedChallenges = [];
                }
                
                // Additional failsafe: Ensure deleted challenge is not in UI
                const deletedChallengeId = this.currentChallenge.uniqueChallengeId;
                this.startedChallenges = this.startedChallenges.filter(c => c.uniqueChallengeId !== deletedChallengeId);
                console.log('Final failsafe filter applied. Final count:', this.startedChallenges.length);
                console.log('=== END DEBUGGING ===');
            } catch (error) {
                console.error('Fehler beim Store-Refresh:', error);
                throw error; // Keine Fallbacks - Cloud Function muss funktionieren
            }
        },
        // Optimiert: Lade nur startedChallenges statt ganzen fitnessPlan
        async loadStartedChallenges() {
            try {
                const userId = this.$store.state.user && this.$store.state.user.user && this.$store.state.user.user.uid;
                if (!userId) return;

                // Lade nur startedChallenges direkt aus dem Store (bereits in Memory)
                const fitnessPlan = this.$store.getters.getFitnessplan;
                if (fitnessPlan && fitnessPlan.startedChallenges) {
                    // Bereinige potentiell verwaiste Challenges (ohne gültigen Server-Zustand)
                    this.startedChallenges = fitnessPlan.startedChallenges.filter(challenge => {
                        // Minimale Validierung: Challenge muss ID und uniqueChallengeId haben
                        return challenge.id && challenge.uniqueChallengeId;
                    });
                    
                    if (this.startedChallenges.length !== fitnessPlan.startedChallenges.length) {
                        console.log('Store-Bereinigung: Ungültige Challenges entfernt', {
                            vorher: fitnessPlan.startedChallenges.length,
                            nachher: this.startedChallenges.length
                        });
                    }
                } else {
                    this.startedChallenges = [];
                }
            } catch (error) {
                console.error('Fehler beim Laden der Started Challenges:', error);
                this.startedChallenges = [];
            }
        },
        
        async loadChallengeStatus() {
            try {
                const userId = this.$store.state.user?.user?.uid;
                if (!userId) {
                    console.error('User ID not available for challenge status');
                    return;
                }
                
                console.log('Loading challenge status from API...');
                this.challengeStatusData = await checkChallengeStatus(userId);
                
                console.log('Challenge status loaded:', this.challengeStatusData);
                
                // Konvertiere Cloud Function Daten zu startedChallenges Format
                if (this.challengeStatusData?.challenges) {
                    this.startedChallenges = this.challengeStatusData.challenges.map(challengeResult => ({
                        id: challengeResult.challengeId,
                        uniqueChallengeId: challengeResult.uniqueChallengeId,
                        inProgress: challengeResult.status === 'in_progress',
                        // Weitere Properties werden in computed properties über challengeData ergänzt
                    }));
                    
                    console.log(`Converted ${this.startedChallenges.length} challenges from Cloud Function`);
                }
                
            } catch (error) {
                console.error('Error loading challenge status:', error);
                this.challengeStatusData = null;
            }
        },
        
        isNotActiveChallenge(challenge) {
            return !this.activeChallenges.some(c => challenge.id === c.id);
        },
    },
}
</script>

<style scoped>

</style>